import { useEffect, useState } from 'react'
import type { AuthMethods } from '@lms/shared-types'
import { fetchAuthMethods } from './auth-client'

/**
 * Used when the methods check fails: today's behaviour, password form shown.
 * A failed request must never hide the only way in.
 */
const FALLBACK: AuthMethods = { password: true, microsoft: false }

/**
 * Which sign-in methods the api accepts here, from `GET /api/v1/auth/methods`.
 * `null` while the check is in flight.
 *
 * Asked at runtime rather than baked into the build: `DEV_PASSWORD_AUTH_ENABLED`
 * is an api setting, and a second copy in the web build could disagree with it,
 * hiding a login that works or showing one that can only 403.
 */
export function useAuthMethods(): AuthMethods | null {
  const [methods, setMethods] = useState<AuthMethods | null>(null)

  useEffect(() => {
    let cancelled = false
    fetchAuthMethods()
      .then((result) => {
        if (!cancelled) setMethods(result)
      })
      .catch(() => {
        if (!cancelled) setMethods(FALLBACK)
      })
    return () => {
      cancelled = true
    }
  }, [])

  return methods
}
